<template>
  <div class="product-carousel-component">
    <b-carousel
      id="product-images"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="100%"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333"
    >
      <b-carousel-slide
        v-for="(image, index) in productImages"
        :key="index"
        :img-src="image"
      >
        <template v-slot:img>
          <img class="image" :src="image" />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "ProductCarousel",
  props: {
    productImages: Array,
  },
};
</script>

<style lang="sass" scoped>
.image
  width: 100%
  height: 553px

.carousel-item
  height: 100%
</style>
